import * as React from 'react';

export const Globe24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path d="M10.2569 21.0856C8.966 19.2767 8.09444 15.8809 8.09444 12.0411C8.09444 8.20133 8.966 4.72333 10.2569 2.95556M13.7431 21.0856C15.034 19.2767 15.9056 15.8809 15.9056 12.0411C15.9056 8.20133 15.034 4.72333 13.7431 2.95556M3.81857 14.96H20.1808M3.81857 9.04H20.1808M2.75 12C2.75 14.4533 3.72455 16.806 5.45926 18.5407C7.19397 20.2754 9.54675 21.25 12 21.25C14.4533 21.25 16.806 20.2754 18.5407 18.5407C20.2754 16.806 21.25 14.4533 21.25 12C21.25 9.54675 20.2754 7.19397 18.5407 5.45926C16.806 3.72455 14.4533 2.75 12 2.75C9.54675 2.75 7.19397 3.72455 5.45926 5.45926C3.72455 7.19397 2.75 9.54675 2.75 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

